var map = {
	"./aflac.png": 3152,
	"./bajibot.png": 40290,
	"./bernzomatic.png": 84911,
	"./bodyarmor.png": 95399,
	"./bridgewater.png": 7330,
	"./buffalotrace.png": 90775,
	"./coronet.png": 36727,
	"./crackerbarrel.png": 22184,
	"./davidortiz.png": 13511,
	"./fotl.png": 51551,
	"./hulu.png": 28492,
	"./maneaddicts.png": 56155,
	"./myspalive.png": 12203,
	"./nbc.png": 48750,
	"./nutiva.png": 21400,
	"./peachy.png": 44936,
	"./planut.png": 15041,
	"./robertmarc.png": 58454,
	"./rowdy.png": 98634,
	"./sarais.png": 84615,
	"./seagrams.png": 57771,
	"./sixplusone.png": 51516,
	"./staffwizard.png": 52433,
	"./syfy.png": 52749,
	"./synchrony.png": 39193,
	"./twsj.png": 18638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 66506;